import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Observable } from 'rxjs';
import { AntiMemLeak } from 'src/app/core/form-utils/anti-mem-leak/anti-mem-leak';
import { ProviderService } from 'src/app/core/provider.service';
import { DatabaseFilterModel } from './models/database-filter.model';
import { MultiSelectModule } from 'primeng/multiselect';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-database-filter',
  imports: [MultiSelectModule, FormsModule, CommonModule, ReactiveFormsModule, TranslateModule],
  templateUrl: './database-filter.component.html',
  styleUrl: './database-filter.component.scss',
})
export class DatabaseFilterComponent extends AntiMemLeak implements OnInit, AfterViewInit {
  @Input() resetFilterObservable?: Observable<any>;
  @Input({ required: true }) formGroupInput!: FormGroup;
  @Input() formControlNameInput = 'databases';
  @Input() singleSelect = false;
  @Input() label?: string;

  loading: boolean = false;
  databases: DatabaseFilterModel[] = [];
  filtredDatabased: DatabaseFilterModel[] = [];

  get isFormControlReady(): boolean {
    return !!this.formGroupInput?.get(this.formControlNameInput);
  }

  constructor(private providerService: ProviderService) {
    super();
  }

  ngOnInit(): void {
    this.getDataBaseList();
  }

  ngAfterViewInit(): void {
    this.subscriptions.add(
      this.resetFilterObservable?.subscribe(() => {
        this.formGroupInput.get(this.formControlNameInput)?.setValue([]);
      })
    );
  }

  async getDataBaseList(): Promise<void> {
    this.loading = true;
    try {
      this.databases = await this.providerService.codesManagementService.getDatabasesList();
      this.filtredDatabased = this.databases;
    } catch (e) {
      console.log(e);
    } finally {
      this.loading = false;
    }
  }

  onFilter(event: any): void {
    const query = event.filter?.toLowerCase() || '';
    if (query === '') {
      this.filtredDatabased = this.databases;
    } else {
      this.filtredDatabased = this.databases.filter((db) => db.databaseName?.toLowerCase().includes(query));
    }
  }

  onChange(event: any): void {
    if (this.singleSelect && event.value && event.value.length > 1) {
      const lastSelected = [event.value[event.value.length - 1]];
      this.formGroupInput.get(this.formControlNameInput)?.setValue(lastSelected);
    }
  }

  getSelectedLabel(): string {
    const selectedDatabases = this.formGroupInput.get(this.formControlNameInput)?.value || [];
    if (selectedDatabases.length === 0) {
      return '';
    }
    if (selectedDatabases.length === 1) {
      return selectedDatabases[0].collectionDescription;
    }
    return `${selectedDatabases[0].collectionDescription} (+${
      selectedDatabases.length - 1
    } ${selectedDatabases.length === 2 ? 'other' : 'others'})`;
  }

  clearFilter(): void {
    this.formGroupInput.get(this.formControlNameInput)?.setValue([], {
      emitEvent: true,
    });
  }
}
